import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

export const CheckedSvg = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M4 9.20879L7 12.4231L14 5.5" stroke="currentColor" strokeWidth="1.5" />
            </svg>
        </SvgIcon>
    );
};
